import React, { ReactNode, useCallback, useEffect } from 'react'

import Banner from '@mc/banner'
import { useBogo } from '@mc/bogo-utils'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { trackBogoNavigationClicked } from '@mc/pre-paywall-events'

import { BOGO_I18N_NAMESPACE, i18nInstance } from '../../i18n'
import { BogoBannerLocation } from '../../types/bogoBanner'
import { trackBogoExperimentViewed } from '../../utils/events'

import { BogoBannerContent } from './components'

interface BogoBannerProps {
  isDark?: boolean
  location?: BogoBannerLocation
  bannerOfferSlogan?: ReactNode
  className?: string
  isGift?: boolean
}

const BogoBannerComponent = ({
  isDark = false,
  location,
  bannerOfferSlogan,
  className = '',
  isGift = false,
}: BogoBannerProps) => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  const { isBogoOfferEligible } = useBogo({ isGift })

  useEffect(() => {
    if (isBogoOfferEligible) {
      trackBogoExperimentViewed()
    }
  }, [isBogoOfferEligible])

  const handleClose = useCallback(() => {
    trackBogoNavigationClicked({
      action: 'dismiss',
      location: 'promotion-banner',
    })
  }, [])

  if (!isBogoOfferEligible) return <></>

  return (
    <Banner
      isClosable
      onClose={handleClose}
      theme={isDark ? 'dark' : 'light'}
      aria-label={t('banner.ariaLabel')}
      className={className}
    >
      <div className='d-flex flex-column flex-md-row align-items-center mc-p-4'>
        <BogoBannerContent
          location={location}
          bannerOfferSlogan={bannerOfferSlogan}
        />
      </div>
    </Banner>
  )
}

export const BogoBanner = withI18nContext(i18nInstance)(BogoBannerComponent)
